export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
    },
    {
      name: 'providers',
      displayName: 'menu.providers',
      meta: {
        icon: 'domain',
      },
    },
    {
      name: 'cartera',
      displayName: 'menu.cartera',
      meta: {
        icon: 'account_balance',
      },
    },
    {
      name: 'invoices',
      displayName: 'menu.invoices',
      meta: {
        icon: 'receipt_long',
      },
    },
    {
      name: 'payment-schedules',
      displayName: 'menu.paymentSchedules',
      meta: {
        icon: 'calendar_month',
      },
    },
    {
      name: 'planilla',
      displayName: 'menu.planilla',
      meta: {
        icon: 'list_alt',
      },
    },
    {
      name: 'inventario',
      displayName: 'menu.inventario',
      meta: {
        icon: 'inventory_2',
      },
    },
    {
      name: 'tarjetas-regalo',
      displayName: 'menu.tarjetasRegalo',
      meta: {
        icon: 'card_giftcard',
      },
    },
    {
      // Not itself a route — AppSidebar.vue only links a `to` when `children` is absent, so
      // this `name` is just an id for the accordion group, never passed to router.push.
      name: 'programa-puntos',
      displayName: 'menu.programaPuntos',
      meta: {
        icon: 'loyalty',
      },
      children: [
        {
          name: 'clientes-puntos',
          displayName: 'menu.clientesPuntos',
          meta: {
            icon: 'badge',
          },
        },
        {
          name: 'premios',
          displayName: 'menu.premios',
          meta: {
            icon: 'redeem',
          },
        },
        {
          name: 'configuracion-puntos',
          displayName: 'menu.configuracionPuntos',
          meta: {
            icon: 'tune',
          },
        },
      ],
    },
    {
      // Not itself a route — AppSidebar.vue only links a `to` when `children` is absent, so
      // this `name` is just an id for the accordion group, never passed to router.push.
      name: 'point-of-sale',
      displayName: 'menu.pointOfSale',
      meta: {
        icon: 'point_of_sale',
      },
      children: [
        {
          name: 'precios',
          displayName: 'menu.precios',
          meta: {
            icon: 'sell',
          },
        },
        {
          name: 'categorias',
          displayName: 'menu.categorias',
          meta: {
            icon: 'category',
          },
        },
        {
          name: 'codigos-barra',
          displayName: 'menu.codigosBarra',
          meta: {
            icon: 'barcode',
          },
        },
      ],
    },
    {
      name: 'preferences',
      displayName: 'menu.preferences',
      meta: {
        icon: 'manage_accounts',
      },
    },
    {
      // Not itself a route — AppSidebar.vue only links a `to` when `children` is absent, so
      // this `name` is just an id for the accordion group, never passed to router.push. The
      // group absorbs the previous flat "settings" item as its first child (unchanged route),
      // plus the new POS sync status screen.
      name: 'configuracion-group',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
      children: [
        {
          name: 'settings',
          displayName: 'menu.settingsGeneral',
          meta: {
            icon: 'tune',
          },
        },
        {
          name: 'pos-sync-status',
          displayName: 'menu.posSyncStatus',
          meta: {
            icon: 'sync',
          },
        },
      ],
    },
  ] as INavigationRoute[],
}
